import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { ICreateUpdateScimConfigurationRequest,ICreateUpdateScimConfigurationResponse, IScimConfiguration } from '../../services/ScimConfigurationsService';

export function createNewScimConfigurationRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.26',
    httpMethod: 'POST',
    endpoint: `scimConfigurations`,
    serverWideRequest: false
  };
}

export function callCreateNewScimConfigurationRequest(scimConfig: IScimConfiguration): Promise<ICreateUpdateScimConfigurationResponse> {
  return makeJsonRestApiRequest<ICreateUpdateScimConfigurationRequest, ICreateUpdateScimConfigurationResponse>({
    config: createNewScimConfigurationRequestConfig(),
    request: {
        scimConfiguration: {
        name: scimConfig.name,
        idpConfigurationId: scimConfig.idpConfigurationId,
        authType: scimConfig.type
      }
    },
  });
}